import React, {Component} from 'react';
import {Button} from 'react-bootstrap';
import axios from 'axios';

export default class ContractUploads extends Component {
    constructor() {
        super();

        this.state = {
            files: [],
            new_files: [],
            next_key: 1,
            max_upload_size: 0,
            min_upload_size: 0,
            max_uploads_count: 0,
            accepted_mime_types: "",
            accepted_extensions: "",
        };

        this.deleteUpload = this.deleteUpload.bind(this);
        this.addUpload = this.addUpload.bind(this);
        this.cancelUpload = this.cancelUpload.bind(this);
    }

    componentWillMount() {
        let upload_config = window.upload_config;
        let uploads = window.uploads;

        let next_key = this.state.next_key;
        for (let key in uploads) {
            if (uploads.hasOwnProperty(key)) {
                uploads[key].key = next_key;
                next_key++;
            }
        }

        this.setState({
            files: uploads,
            // new_files: new_files,
            next_key: next_key,
            max_upload_size: upload_config.max_upload_size,
            min_upload_size: upload_config.min_upload_size,
            max_uploads_count: upload_config.max_uploads_count,
            accepted_mime_types: upload_config.accepted_mime_types,
            accepted_extensions: upload_config.accepted_extensions,
        });
    }

    deleteUpload(key) {
        if (confirm(window.__js_contracts.delete_file_verify)) {
            let files = this.state.files;
            let file_to_delete = files.find((item) => item.key === key);
            axios
                .get("/contracts/manage_contracts/uploads/" + file_to_delete.contract_id + "/" + file_to_delete.id + "/delete")
                .then((response) => {
                    files = files.filter((item) => item.key !== key);
                    this.setState({files});
                });
        }
    }

    addUpload() {
        let new_files = this.state.new_files;
        let next_key = this.state.next_key;
        new_files.push({
            key: next_key,
            name: "file" + next_key
        });
        next_key++;
        this.setState({new_files, next_key});
    }

    cancelUpload(key) {
        let new_files = this.state.new_files;
        new_files = new_files.filter((item) => item.key !== key);
        this.setState({new_files});
    }

    render() {
        let rows = this.state.files.map(f => (
            <tr key={f.key}>
                <td>
                    <a href={f.url} target="_blank">
                        {f.name}
                    </a>
                </td>
                <td>
                    <Button onClick={() => this.deleteUpload(f.key)}
                            bsStyle="danger">
                        <i className="fa fa-trash"></i> {window.__js_contracts.delete}
                    </Button>&nbsp;
                    <a href={f.url}
                       target="_blank"
                       className={"btn btn-primary"}>
                        <i className="fa fa-cloud-download"></i> {window.__js_contracts.download}
                    </a>
                </td>
            </tr>
        ));

        if (rows.length === 0) {
            rows.push(
                <tr key="0">
                    <td colSpan="2">
                        <em>{window.__js_contracts.no_attached_files}</em>
                    </td>
                </tr>
            );
        }

        let new_rows = this.state.new_files.map(f => (
            <tr key={f.key}>
                <td><input type="file" name="uploads[]" className="form-control"/></td>
                <td>
                    <Button onClick={() => this.cancelUpload(f.key)}
                            bsStyle="danger">
                        <i className="fa fa-times"></i>
                    </Button>
                </td>
            </tr>
        ));

        if (new_rows.length === 0) {
            new_rows.push(
                <tr key="0">
                    <td colSpan="2">
                        <em>
                            {window.__js_contracts.add_files_msg} <strong>&laquo;+&raquo;</strong>.
                        </em>
                    </td>
                </tr>
            );
        }

        return (
            <div>
                <div className="row">
                    <div className="col-sm-offset-4 col-sm-8">
                        <legend>
                            {window.__js_contracts.attached_files} &nbsp;
                            <span
                                style={{color: ((this.state.files.length + this.state.new_files.length) >= this.state.max_uploads_count ? "red" : "")}}>
                                ({(this.state.files.length + this.state.new_files.length)}/{this.state.max_uploads_count})
                            </span>
                        </legend>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4">
                        <p><strong>{window.__js_contracts.add_files}</strong></p>
                        <div className="table-responsive">
                            <table className="table table-bordered table-striped table-hover">
                                <thead>
                                <tr>
                                    <th>{window.__js_contracts.file_to_upload}</th>
                                    <th>{window.__js_general.cancellation}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {new_rows}
                                </tbody>
                            </table>
                        </div>
                        <Button onClick={this.addUpload}
                                bsStyle="success"
                                className={(this.state.files.length + this.state.new_files.length) >= this.state.max_uploads_count ? "hidden" : ""}>
                            <i className="fa fa-plus"></i>
                        </Button>
                        <p>{window.__js_contracts.use_table_to_add_files}</p>
                        <p>{window.__js_contracts.filetypes}: {this.state.accepted_extensions}</p>
                    </div>
                    <div className="col-md-8">
                        <p><strong>{window.__js_contracts.existing_files}</strong></p>
                        <div className="table-responsive">
                            <table className="table table-bordered table-striped table-hover">
                                <thead>
                                <tr>
                                    <th>{window.__js_contracts.file_name}</th>
                                    <th>{window.__js_contracts.actions}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {rows}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}